module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "change-user-data"
  }, [(_vm.state == 'done') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().done.title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_vm._v("\n      " + _vm._s(_vm.i18n().done.text) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.state != 'done' && _vm.state != 'loading') ? _c('form', {
    staticClass: "mdl-card mdl-shadow--2dp",
    on: {
      "submit": _vm.change
    }
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_c('div', {
    class: {
      blurred: _vm.state == 'working'
    }
  }, [(_vm.error) ? _c('div', {
    staticClass: "serverError"
  }, [_vm._v(_vm._s(_vm.i18n().errors[_vm.error] || _vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedUserData.firstName),
      expression: "editedUserData.firstName"
    }],
    ref: "firstName",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "firstName",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.editedUserData.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editedUserData, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v(_vm._s(_vm.i18n().firstName))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedUserData.lastName),
      expression: "editedUserData.lastName"
    }],
    ref: "lastName",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "lastName",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.editedUserData.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editedUserData, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v(_vm._s(_vm.i18n().lastName))])]), _vm._v(" "), _c('PhoneInput', {
    staticClass: "phoneNumber field",
    attrs: {
      "value": _vm.editedUserData.phoneNumber,
      "required": _vm.required,
      "invalid": _vm.phoneNumberInvalid,
      "label": _vm.i18n().phoneNumber
    },
    on: {
      "update:value": function($event) {
        _vm.$set(_vm.editedUserData, "phoneNumber", $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedUserData.companyName),
      expression: "editedUserData.companyName"
    }],
    ref: "companyName",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "companyName",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.editedUserData.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editedUserData, "companyName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "companyName"
    }
  }, [_vm._v(_vm._s(_vm.i18n().companyName))])]), _vm._v(" "), _c('CountryInput', {
    staticClass: "country field",
    attrs: {
      "value": _vm.editedUserData.country,
      "required": _vm.required,
      "invalid": _vm.countryInvalid,
      "label": _vm.i18n().country
    },
    on: {
      "update:value": function($event) {
        _vm.$set(_vm.editedUserData, "country", $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedUserData.city),
      expression: "editedUserData.city"
    }],
    ref: "city",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "city",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.editedUserData.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editedUserData, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "city"
    }
  }, [_vm._v(_vm._s(_vm.i18n().city))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedUserData.addressLine1),
      expression: "editedUserData.addressLine1"
    }],
    ref: "addressLine1",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "addressLine1",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.editedUserData.addressLine1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editedUserData, "addressLine1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "addressLine1"
    }
  }, [_vm._v(_vm._s(_vm.i18n().addressLine1))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedUserData.addressLine2),
      expression: "editedUserData.addressLine2"
    }],
    ref: "addressLine2",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "addressLine2"
    },
    domProps: {
      "value": (_vm.editedUserData.addressLine2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editedUserData, "addressLine2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "addressLine2"
    }
  }, [_vm._v(_vm._s(_vm.i18n().addressLine2))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedUserData.postalCode),
      expression: "editedUserData.postalCode"
    }],
    ref: "postalCode",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "postalCode"
    },
    domProps: {
      "value": (_vm.editedUserData.postalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editedUserData, "postalCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "postalCode"
    }
  }, [_vm._v(_vm._s(_vm.i18n().postalCode))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedUserData.taxNumber),
      expression: "editedUserData.taxNumber"
    }],
    ref: "taxNumber",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "taxNumber"
    },
    domProps: {
      "value": (_vm.editedUserData.taxNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editedUserData, "taxNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "taxNumber"
    }
  }, [_vm._v(_vm._s(_vm.i18n().taxNumber))])])], 1), _vm._v(" "), (_vm.state == 'working') ? _c('div', {
    staticClass: "working"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border",
    class: {
      blurred: _vm.state == 'working'
    }
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "disabled": !_vm.dataEdited,
      "type": "submit"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n().submit) + "\n      ")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7912b981"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/ChangeUserData.vue
// module id = 460
// module chunks = 0